const state = {
  item: {},
  location: null
}

const mutations = {
  closeAddBaseRefPopup (state) {
    state.item = {}
    state.location = {}
  },
  openAddBaseRefPopup (state, data) {
    state.item = data.item
    state.location = data.location
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
